module.exports = __webpack_public_path__ + "static/media/INDIAN.2321127c.svg";